<template>
  <div class='preview'>
    <p class="has" v-if="differenceLength<=0">{{t('ai.identical')}}</p>
    <div class="preview-title-box flex" v-if="differenceLength">
      <img :src="image.ai" alt="" class="preview-img-size">
      <span class="preview-title">{{title}}</span>
      <span class="preview-warning">{{t('ai.itemsNeedConfirmed',{num:differenceLength})}}</span>
    </div>
    <div class="preview-content-box" v-if="differenceLength">
      <el-row :gutter="10">
        <el-col :span="item.size" v-for="(item,index) in dataList.cvResDto" :key="index" class="item-col" :class="{'item-col-block':item.block}">
          <p class="item-col-label" :class="{'isMatch':!item.isMatch}">{{item.label}}</p>
          <p class="item-col-value">{{item.value}}</p>
        </el-col>
      </el-row>
      <el-button @click="handleAllPreview" type="primary" size="small">
        {{t('ai.replaceAll')}}
      </el-button>
      <el-button @click="handleCancel" size="small">
        {{t('common.cancel')}}
      </el-button>
    </div>
  </div>
</template>

<script>
import i18n from "@/locale/index";
import {getAiData} from '@/utils/session_storage.js'
export default {
  inject: ['hideSubmitBtn','formType'],
  mixins: [i18n],
  tickTime: '',
  data(){
    return {
      image:{
        ai:require('@/assets/ai-upload/AI.png'),
      },
      dataList:{
        usedFileGuid:'',
        cvResDto:[],
      },
      differenceLength:0,
    }
  },
  props:{
    title:{
      default:'',
    },
    // previewData:{
    //   type: Array,
    //   defalut: () => []
    // }
  },
  computed:{

  },
  watch: {
    // previewData:{
    //   deep: true,
    //   immediate: true,
    //   handler(newVal){
    //     this.differenceLength=0;
    //     this.dataList=[];
    //     if(newVal&&newVal.length){
    //       for(const item of newVal){
    //         if(!item.isMatch){
    //           this.differenceLength++;
    //         }
    //       }
    //       this.dataList=newVal;
    //     }
    //   }
    // }
  },
  mounted(){
    let reqData=getAiData();
    if(reqData){
      reqData=JSON.parse(reqData);
    }
    this.differenceLength=0;
    this.dataList={
      fileInfo:'',
      cvResDto:[],
      attachMap:[]
    };
    if(reqData.cvResDto&&reqData.cvResDto.length){
      for(const item of reqData.cvResDto){
        if(!item.isMatch){
          this.differenceLength++;
        }
      }
      this.dataList.attachMap=reqData.attachMap;
      this.dataList.fileInfo=reqData.fileInfo;
      this.dataList.cvResDto=reqData.cvResDto;
    }
  },
  methods:{
    handleAllPreview(){
      this.$emit('handleAllPreview',this.dataList)
    },
    handleCancel(){
      this.$emit('handleAiCancel')
    }
  }
}
</script>

<style lang='scss' scoped>
.flex{
  display: flex;
  align-items:center;
}
.isMatch{
  color: #E84C57 !important;
}
.has{
  color: #FF9600;
  font-size:14px;
  text-align: center;
}
.preview-content-box{
  text-align: left;
}
.preview{
  padding:12px 16px;
  border-radius: 10px;
  background: #FFF8EE;
  .preview-title-box{
    margin-bottom: 10px;
    .preview-img-size{
      width:18px;
      height:18px;
    }
    .preview-title{
      color: #FF9600;
      font-size:14px;
      margin:0 10px 0 8px;
    }
    .preview-warning{
      border-radius: 4px;
      background: #FAEBEB;
      font-size: 12px;
      color: #DB4A4E;
      padding: 2px 8px;
    }
  }
  .item-col{
    
    font-size: 14px;
    display: inline-block;
    .item-col-label{
      color:#999;
      margin-bottom:10px;
    }
    .item-col-value{
      color:#333;
      margin-bottom:18px;
    }
  }
  .item-col-block{
    clear: both !important;
  }
}
</style>